// existing code hidden for display purpose

import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { RepoBusinessEffects } from './repo-business/repo-business.effect';
import { RepoBusinessFacade } from './repo-business/repo-business.facade';
import { repoBusinessReducer } from './repo-business/repo-business.reducer';
import { SalesEffect } from './sales/sales.effect';
import { SalesFacade } from './sales/sales.facade';
import { saleReducer } from './sales/sales.reducer';

import { StatistcsEffect } from './statistics/statistics.effect';
import { StatisticsFacade } from './statistics/statistics.facade';
import { statisticsReducer } from './statistics/statistics.reducer';

import { RecoveryEffect } from './recovery/recovery.effect';
import { RecoveryFacade } from './recovery/recovery.facade';
import { recoveryReducer } from './recovery/recovery.reducer';

import { MailEffect } from './mail/mail.effect';
import { MailFacade } from './mail/mail.facade';
import { mailReducer } from './mail/mail.reducer';

import { StudiesEffect } from './studies/studies.effect';
import { StudiesFacade } from './studies/studies.facade';
import { studyReducer } from './studies/studies.reducer';
import { UserEffects } from './user-management/user.effect';
import { UserFacade } from './user-management/user.facade';
import { userReducer } from './user-management/user.reducer';

import { SubmissionsFacade } from './submissions/submissions.facade';
import { VetSettingsEffects } from './vet-settings/vet-settings.effects';
import { VetSettingsFacade } from './vet-settings/vet-settings.facade';
import { vetSettingsReducer } from './vet-settings/vet-settings.reducer';

import { SubmissionsEffect } from './submissions/submissions.effect';
import { submissionsReducer } from './submissions/submissions.reducer';

@NgModule({
  imports: [
    StoreModule.forFeature('studies', studyReducer),
    StoreModule.forFeature('sales', saleReducer),
    StoreModule.forFeature('recovery', recoveryReducer),
    StoreModule.forFeature('mail', mailReducer),
    StoreModule.forFeature('statistics', statisticsReducer),
    StoreModule.forFeature('user', userReducer),
    EffectsModule.forFeature([
      StudiesEffect,
      SalesEffect,
      RecoveryEffect,
      MailEffect,
      StatistcsEffect,
      UserEffects,
    ]),
    StoreModule.forFeature('repoBusiness', repoBusinessReducer),
    EffectsModule.forFeature([StudiesEffect, RepoBusinessEffects]),
    StoreModule.forFeature('vetSettings', vetSettingsReducer),
    EffectsModule.forFeature([VetSettingsEffects]),

    StoreModule.forFeature('submissions', submissionsReducer),
    EffectsModule.forFeature([SubmissionsEffect]),
  ],

  providers: [
    StudiesFacade,
    SalesFacade,
    RepoBusinessFacade,
    RecoveryFacade,
    MailFacade,
    StatisticsFacade,
    UserFacade,
    VetSettingsFacade,
    SubmissionsFacade,
  ],
})
export class SharedStoreModule {}
